import React from "react";
import Paper from "@mui/material/Paper"
import Grid from '@mui/material/Grid2';

import Typography from "@mui/material/Typography";
import OpenFormButton from "./OpenFormButton";
import BookingsList from "./BookingsList";

const name = "BookingsInProgress";

const BookingsInProgress: React.FC = () => {
    return (<Grid container spacing={1} flexBasis="19%" flexGrow={1} sx={{ mt: -1 }}>
        <Paper sx={(theme) => ({
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            padding: theme.spacing(1)
        })} elevation={4}>
            <Typography sx={{ textAlign: "center" }}>BOOKINGS IN PROGRESS</Typography>
            <BookingsList />
            <OpenFormButton />
        </Paper>
    </Grid>)
}

BookingsInProgress.displayName = name;

export default React.memo(BookingsInProgress);